import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { IntegratedPlatform, IntegrationPlatformType } from './models/integration.model';
import { IntegrationsService } from './integration.service';
import { map } from 'rxjs/operators';

@Injectable()
export class SingleIntegrationResolver implements Resolve<MaybePlatformWithType> {
  constructor(private integrationsService: IntegrationsService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MaybePlatformWithType> {
    const type = route.paramMap.get('integratedPlatformType').toUpperCase() as IntegrationPlatformType;

    return this.integrationsService.getIntegration(type).pipe(
      map(platform => ({
        platform,
        type
      }))
    );
  }
}

export interface MaybePlatformWithType {
  platform?: IntegratedPlatform;
  type: IntegrationPlatformType;
}
